/**
 * CreateDealForm — Inline form for manually creating a deal in the sidebar.
 * Address is required; intended use is optional.
 */

import { useState } from "react";

interface CreateDealFormProps {
  onCreated: (deal: { address: string; intended_use?: string }) => void;
  onCancel: () => void;
  submitting?: boolean;
}

const INTENDED_USES = [
  { value: "", label: "Select (optional)" },
  { value: "Investment", label: "Investment" },
  { value: "Owner-Occupied", label: "Owner-Occupied" },
  { value: "Development", label: "Development" },
  { value: "Land Bank", label: "Land Bank" },
];

export default function CreateDealForm({ onCreated, onCancel, submitting }: CreateDealFormProps) {
  const [address, setAddress] = useState("");
  const [intendedUse, setIntendedUse] = useState("");

  const canSubmit = address.trim().length > 0 && !submitting;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!canSubmit) return;
    onCreated({
      address: address.trim(),
      intended_use: intendedUse || undefined,
    });
  };

  return (
    <form className="create-deal-form" onSubmit={handleSubmit}>
      <div className="create-deal-field">
        <label className="create-deal-label">Address</label>
        <input
          type="text"
          className="create-deal-input"
          placeholder="e.g. 1810 E 106th St, Carmel"
          value={address}
          onChange={(e) => setAddress(e.target.value)}
          autoFocus
          disabled={submitting}
        />
      </div>
      <div className="create-deal-field">
        <label className="create-deal-label">Intended Use</label>
        <select
          className="create-deal-select"
          value={intendedUse}
          onChange={(e) => setIntendedUse(e.target.value)}
          disabled={submitting}
        >
          {INTENDED_USES.map((u) => (
            <option key={u.value} value={u.value}>
              {u.label}
            </option>
          ))}
        </select>
      </div>
      <div className="create-deal-actions">
        <button type="button" className="create-deal-cancel" onClick={onCancel} disabled={submitting}>
          Cancel
        </button>
        <button type="submit" className="create-deal-submit" disabled={!canSubmit}>
          {submitting ? (
            <>
              <span className="spinner" style={{ width: 12, height: 12, borderWidth: 1.5 }} /> Creating...
            </>
          ) : (
            "Create & Analyze"
          )}
        </button>
      </div>
    </form>
  );
}
